<template>
  <v-container grid-list-xs>
    <v-alert v-if="user"
             type="success"
             transition="fade-transition"
             v-model="alert"
             dismissible
    >You are logged in!
    </v-alert>
    <v-layout row wrap>
      <v-flex v-for="story in getStories" :key="story.id" xs12 md6 xl3 pa-2>
        <v-card
          @click="$router.push({name: 'detail', params:{ story }})"
          :class="{ 'blue lighten-3': story.data.markAsRead}"
          :outlined="true">
          <v-card-title primary-title >
            {{ story.data.title }}
          </v-card-title>
          <v-card-subtitle>
            {{ story.data.signature }}
          </v-card-subtitle>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import { mapGetters } from 'vuex';

  export default {
    data() {
      return {
        alert: false,
        perPage: 26,
        page: 1,
        lastSnapshot: null,
        firstSnapshot: null
      };
    },
    computed: {
      ...mapGetters({
        user: 'user',
        stories: 'stories'
      }),
      getStories() {
        return this.stories;
      }
    },
    mounted() {
    },
    methods: {

    }
  };
</script>

<style>
</style>
